import { useCallback } from "react";
import { useParams } from "react-router-dom";
import { usePlaylistDetail } from "frontend/src/domain/playlists";
import { pause, resume } from "frontend/src/features/control-audio";
import { playPlaylistAttempted } from "frontend/src/features/play-playlist";
export var usePageModel = function () {
    var id = useParams().id;
    var playlist = usePlaylistDetail(Number(id)).playlist;
    return playlist;
};
export var usePlay = function (playlist) {
    var play = useCallback(function (_a) {
        var selected = _a.selected, index = _a.index;
        if (selected) {
            resume();
        }
        else {
            playPlaylistAttempted({
                id: playlist.id,
                title: playlist.title,
                startAtTrackIndex: index,
                tracks: playlist.tracks,
            });
        }
    }, [playlist]);
    return { play: play, pause: pause };
};
